import { jsx as _jsx } from "jsx-dom/jsx-runtime";
import xhr from "./xhr.js";
import { selectAll } from "@fruugo/utilities";
var ariaLabelMap = {
    Paypal: "PayPal",
    "Paypal Express": "PayPal Express Checkout",
    "Apple Pay": "Apple Pay",
    "Apple Pay Express": "Apple Pay Express Checkout",
    "Google Pay": "Google Pay",
    "Google Pay Express": "Google Pay Express Checkout",
    visa: "Visa",
    mc: "Mastercard",
    maestro: "Maestro",
    amex: "American Express",
    Klarna: "Klarna",
    "Klarna Express Checkout": "Klarna Express Checkout",
    "Klarna Instant": "Klarna Instant",
    discover: "Discover",
    jcb: "JCB",
    Alipay: "Alipay",
    Clearpay: "Clearpay",
};
var paymentMethodSlugBlacklist = [
    "paypalexpress",
    "applepayexpress",
    "googlepayexpress",
    "klarnaexpresscheckout",
    "klarnainstant",
    "unionpay",
];
function isPaymentMethodEnabled(paymentMethod) {
    var slug = slugifyName(paymentMethod);
    return !paymentMethodSlugBlacklist.includes(slug);
}
function getPaymentMethodsList(forceFetch) {
    return new Promise(function (resolve) {
        var key = "paymentMethods_" + window.currentCountry;
        var cached = sessionStorage.getItem(key);
        if (cached === null || forceFetch) {
            xhr("/marketplace/api/payment-methods").then(function (_a) {
                var response = _a.response;
                sessionStorage.setItem(key, response);
                resolve(JSON.parse(response));
            });
        }
        else {
            resolve(JSON.parse(cached));
        }
    });
}
function slugifyName(name) {
    return name.replace(/\s+/g, "").toLowerCase();
}
function buildIcons(paymentMethods) {
    return (_jsx("div", { class: "icon-pay-list", children: paymentMethods.filter(isPaymentMethodEnabled).map(function (paymentMethod) { return (_jsx("span", { role: "img", "aria-label": ariaLabelMap[paymentMethod] || paymentMethod, className: "icon icon-pay icon-pay--".concat(slugifyName(paymentMethod)) })); }) }));
}
function addIconsToDom(elements, icons) {
    elements.forEach(function (element) { return element.replaceChildren(icons.cloneNode(true)); });
}
export function initPaymentIcons(selector, forceFetch) {
    if (selector === void 0) { selector = ".js-payment-icons"; }
    if (forceFetch === void 0) { forceFetch = false; }
    var elements = selectAll(selector);
    if (elements === null)
        return;
    getPaymentMethodsList(forceFetch)
        .then(buildIcons)
        .then(function (icons) { return addIconsToDom(elements, icons); });
}
